import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { isEmpty, get, find, filter, sumBy } from "lodash";
import { GetLevelFourDropDownApi } from "../LevelFour/LevelFourAction";
import { AddVoucherApi, GetCreditDebitApi, SubmitJournal, DeleteJournal, ResetJournal } from "./VoucherAction";
import { setHeading } from "../../../accounts/account.actions";
import { previewVoucher } from '../../../../../global/globalFunctions'
import moment from "moment";
import Spinner from "react-bootstrap/Spinner";
import MaterialTable from "material-table";
import Select from "react-select";
import Swal from 'sweetalert';
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const JournalVoucher = (props) => {
    const [voucher, setVoucher] = useState();
    const [datestate, setDatestate] = useState(moment().format("YYYY-MM-DD"));
    const [level4Id, setLevel4Id] = useState(2);
    const [visibleAlert, setAlertVisible] = useState(false);
    const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);


    const SaveJournalVoucher = () => {
        props.AddVoucherApi({
            voucherTypeId: "5",
            vocDate: datestate,
            voucher: voucher,
            levelFourId: cash.map((x) => {
                return x.journalData.levelFourId;
            }),
            voucherData: cash.map((x) => {
                return x.journalData;
            }),
            voucherType: "JV",
        },
            handleVisible,
            handleDangerVisible
        );
        props.ResetJournal();
    };
    const handleVisible = (data, msg) => {
        setAlertVisible(true)
        setTimeout(() => {
            setAlertVisible(false)
        }, 9000);
        Swal({
            title: "Success",
            text: msg,
            icon: "success",
            buttons: ["Cancel", "Print Voucher"]
        }).then((willPrint) => {
            if (willPrint) {
                previewVoucher(data, "Pending");
            }
        })
    }
    const handleDangerVisible = (err) => {
        setDangerVisibleAlert(true)
        setTimeout(() => {
            setDangerVisibleAlert(false)
        }, 9000);
        Swal({
            title: "Error",
            text: err,
            icon: "error",
            button: "Ok",
        });
    }

    let creditSum = 0
    let debitSum = 0

    const cash = props.journal;
    cash.map((x) => {
        if (x.journalData.accountType == 1) {
            creditSum = creditSum + Number(x.journalData.voucherAmount);
        } else if (x.journalData.accountType == 2) {
            debitSum = debitSum + Number(x.journalData.voucherAmount);
        }
    });

    const [values, setValues] = useState({
        voucherDescription: "",
        voucherAmount: "",
        billNumber: "",
        accountTittle: "",
        levelFourId: "",
        voucherDate: "",
        accountType: "-1",
        credit: "",
        debit: "",
        crossAccount: ""
    });

    const inputEventAccount = (selectedOption, type) => {
        setLevel4Id(selectedOption.value);
        setValues({
            levelFourId: selectedOption.value,
        });
    };

    const inputEvent1Account = (selectedOption) => {
        setLevel4Id(selectedOption.value);
        setValues({
            ...values,
            "levelFourId": selectedOption.value,
            "accountTittle":
                get(find(props.levelFourDropDownList, (x) => x._id === selectedOption.value), "allLevelKey", 0) + "(" +
                get(find(props.levelFourDropDownList, (x) => x._id === selectedOption.value), "levelFourName", 0) + ")",
        });
    };

    const inputEvent = (event) => {
        event.target.name == "voucherDate" && setDatestate(event.target.value);
        if (event.target.name == "voucherAmount") {
            setValues({
                ...values,
                [event.target.name]: event.target.value,
                debit: Number(event.target.value),
                credit: Number(event.target.value)
            })
        } else {
            setValues({
                ...values,
                [event.target.name]: event.target.value,
            })
        }
    };

    const cashAccountNo = !isEmpty(props.levelFourDropDownList) && props.levelFourDropDownList.map((x) => {
        let data = {
            value: x._id,
            label: `${x.allLevelKey} / ${x.levelFourName}`,
        };
        return data;
    });

    const PostVoucher = () => {
        let newVal = values;
        if (!isEmpty(datestate)) newVal.voucherDate = datestate;
        props.SubmitJournal(newVal);
        setValues({
            voucherDescription: newVal.voucherDescription,
            voucherAmount: newVal.voucherAmount,
            PONo: "",
            billNumber: "",
            accountTittle: "",
            payTo: "",
            levelFiveId: "",
            voucherDate: "",
            accountType: "-1",
            credit: "",
            debit: "",
            crossAccount: ""
        });
    };

    useEffect(() => {
        props.GetCreditDebitApi();
        props.GetLevelFourDropDownApi();
        props.setHeading("Journal Voucher");
    }, []);

    return (
        <>
            {props.isFetchingLevelFourDropDown || props.isAddingVoucher ? (
                <div className="loader-div">
                    <Spinner
                        variant="primary"
                        animation="border"
                        size="xl"
                        role="status"
                        aria-hidden="true"
                    />
                </div>
            ) : (
                <Container fluid>
                    <Row>
                        <Col>
                            <Form.Group >
                                <Form.Label><b>Voucher Date *</b></Form.Label>
                                <Form.Control
                                    type="date"
                                    name="voucherDate"
                                    value={datestate}
                                    max={moment().format("YYYY-MM-DD")}
                                    onChange={inputEvent}
                                    disabled={!isEmpty(props.journal)}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label><b>Total Debts</b></Form.Label>
                                <Form.Control
                                    type="text"
                                    name="voucherDate"
                                    value={sumBy(filter(cash, x => x.journalData.accountType == '2'), item => Number(item.journalData.voucherAmount))}
                                    disabled={true}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label><b>Total Credit</b></Form.Label>
                                <Form.Control
                                    type="text"
                                    name="voucherDate"
                                    value={sumBy(filter(cash, x => x.journalData.accountType == '1'), item => Number(item.journalData.voucherAmount))}
                                    disabled={true}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label><b>Difference</b></Form.Label>
                                <Form.Control
                                    type="text"
                                    name="voucherDate"
                                    value={Math.abs(sumBy(filter(cash, x => x.journalData.accountType == '1'), item => Number(item.journalData.voucherAmount)) - sumBy(filter(cash, x => x.journalData.accountType == '2'), item => Number(item.journalData.voucherAmount)))}
                                    isInvalid={!Math.abs(sumBy(filter(cash, x => x.journalData.accountType == '1'), item => Number(item.journalData.voucherAmount)) == sumBy(filter(cash, x => x.journalData.accountType == '2'), item => Number(item.journalData.voucherAmount)))}
                                    disabled={true}
                                />

                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label><b>Select Account *</b></Form.Label>
                                <Select
                                    value={{ label: values.accountTittle }}
                                    placeholder="Select Account"
                                    onChange={(inputEventAccount, inputEvent1Account)}
                                    options={cashAccountNo}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label><b>Account Type *</b></Form.Label>
                                <Form.Control
                                    as="select"
                                    name="accountType"
                                    value={values.accountType}
                                    onChange={inputEvent}
                                >
                                    <option value="-1" selected>
                                        Select an option
                                    </option>
                                    <option value="2">Debit</option>
                                    <option value="1">Credit</option>
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label><b>Bill Number</b></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Bill Number"
                                    name="billNumber"
                                    value={values.billNumber}
                                    onChange={inputEvent}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label><b>Description</b></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Description"
                                    name="voucherDescription"
                                    value={values.voucherDescription}
                                    onChange={inputEvent}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label><b>Voucher Amount *</b></Form.Label>
                                <Form.Control
                                    type="number"
                                    placeholder="Voucher Amount"
                                    name="voucherAmount"
                                    min={0}
                                    value={values.voucherAmount}
                                    onChange={inputEvent}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '80px', marginTop: '15px' }}>
                        <div>
                            <Button
                                variant="contained"
                                endIcon={<SendIcon />}
                                size="large"
                                disabled={isEmpty(datestate) || isEmpty(values.voucherAmount) || values.accountType == "-1" || isEmpty(values.levelFourId)}
                                onClick={() => { PostVoucher() }}>
                                <b> POST VOUCHER </b>
                            </Button>
                        </div>
                        <div>
                            {creditSum !== 0 && debitSum !== 0 && creditSum === debitSum ? (
                                <Button
                                    variant="contained"
                                    endIcon={<SendIcon />}
                                    size="large"
                                    onClick={SaveJournalVoucher}>
                                    <b>SAVE VOUCHER </b>
                                </Button>
                            ) : (
                                <Button
                                    variant="contained"
                                    endIcon={<SendIcon />}
                                    size="large"
                                    disabled={true}>
                                    <b> SAVE VOUCHER </b>
                                </Button>
                            )}
                        </div>
                    </div>

                    <div className="main" style={{ marginTop: '10px' }} >
                        <MaterialTable
                            title={`VOUCHER TOTAL : ${sumBy(cash, item => Number(item.journalData.voucherAmount))}`}
                            columns={[
                                { title: "Date", field: "journalData.voucherDate" },
                                { title: "Account Name", field: "journalData.accountTittle" },
                                { title: "Bill", field: "journalData.billNumber" },
                                { title: "Description", field: "journalData.voucherDescription" },
                                { title: "Amount", field: "journalData.voucherAmount", render: rowData => `${rowData.journalData.voucherAmount}/-` },
                                { title: "Debit / Credit", field: "journalData.accountType", render: (rowData) => rowData.journalData.accountType === "1" ? "Credit" : "Debit" },
                            ]}
                            data={cash}
                            options={{
                                actionsColumnIndex: -1,
                                exportButton: false,
                                exportAllData: false,
                                paging: false,
                                pageSize: 50,
                                emptyRowsWhenPaging: false,
                                pageSizeOptions: [50, 100, 150, 200],
                                headerStyle: {
                                    position: "sticky",
                                    top: 0,
                                    color: "#00BBBB",
                                    fontWeight: "550",
                                    onRowAdd: "none",
                                },
                            }}
                            editable={{
                                onRowDelete: (oldData) =>
                                    new Promise((resolve) => {
                                        setTimeout(() => {
                                            resolve();
                                            props.DeleteJournal(oldData);
                                        }, 600);
                                    }),
                            }}
                        />
                    </div>

                </Container >
            )}
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
        AddVoucherApi: (data, handleVisible, handleDangerVisible) => dispatch(AddVoucherApi(data, handleVisible, handleDangerVisible)),
        GetLevelFourDropDownApi: () => dispatch(GetLevelFourDropDownApi()),
        GetCreditDebitApi: () => dispatch(GetCreditDebitApi()),
        SubmitJournal: (data) => dispatch(SubmitJournal(data)),
        DeleteJournal: (id) => dispatch(DeleteJournal(id)),
        ResetJournal: () => dispatch(ResetJournal()),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isAddingVoucher: state.VouchersReducer.isAddingVoucher,
    journal: state.VouchersReducer.journal,
    isFetchingLevelFourDropDown: state.LevelFourReducer.isFetchingLevelFourDropDown,
    levelFourDropDownList: state.LevelFourReducer.levelFourDropDownList,
    isFetchingCreditDebit: state.VouchersReducer.isFetchingCreditDebit,
    creditDebitList: state.VouchersReducer.creditDebitList,
});


export default connect(mapStateToProps, mapDispatchToProps)(JournalVoucher);